import { render, staticRenderFns } from "./IconArrowUp.vue?vue&type=template&id=17bf2f60"
import script from "./IconArrowUp.vue?vue&type=script&lang=js"
export * from "./IconArrowUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports